import React, {useEffect, useRef, useState} from "react";
import BackgroundImage from "./BackgroundImage";
import {ImageWrapper, Placeholder} from "./StyledBgImage";
import {useObserver} from "Hooks/useObserver";

const LazyBackgroundImage = ({
                                 source,
                                 height,
                                 minHeight,
                                 timeout = 200,
                                 children,
                                 paddingBottom,
                                 useFocalPoint,
                                 HeroCurvedTextArea,
                                 smallBorderRadius,
                                 alt
                             }) => {
    const domRef = useRef();
    const [isVisible, setVisible] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    const [placeholderSource, setPlaceholderSource] = useState("");

    const observe = useObserver(domRef);
    useEffect(() => {
        if (!isVisible && observe) {
            setVisible(true);
        }
    }, [observe]);

    useEffect(() => {
        if (isVisible) {
            setTimeout(() => setFadeIn(isVisible), timeout);
        }
    }, [isVisible]);

    useEffect(() => {
        if (source != undefined) {
            let query = source.indexOf("?") > -1 ? "&height=10" : "?height=10";
            setPlaceholderSource(source + query);
        }
    }, []);

    return (
        <ImageWrapper paddingBottom={paddingBottom} height={height} ref={domRef} minHeight={minHeight}>
            <Placeholder placeholder={placeholderSource} fadeIn={true}/>
            {isVisible && (
                <BackgroundImage
                    source={source}
                    onLoad={fadeIn}
                    useFocalPoint={useFocalPoint}
                    HeroCurvedTextArea
                    smallBorderRadius={smallBorderRadius}
                    alt={alt}
                >
                    {children != undefined && children}
                </BackgroundImage>
            )}
        </ImageWrapper>
    );
};

export default LazyBackgroundImage;
